module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ftit"
  }, [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("E"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("DITORS’")]), _vm._v(" P"), _c('span', {
    staticClass: "chsmall"
  }, [_vm._v("REFACE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "gray"
  }, [_vm._v("T"), _c('span', {
    staticClass: "chsmallb"
  }, [_vm._v("HE TEXT")])]), _vm._v(" that follows was transcribed from a manuscript prepared by W. F. Oscar Federhen, a Union soldier in the Civil War who served in 1864 and 1865.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Federhen probably wrote his first draft after 1869 because the notebook in which he wrote his recollections was purchased from George B. Brown and Co., Stationers, of 94 State Street in Boston. According to existing city directories, that business was located at that address between 1869 and 1872.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f00xi-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A spread from Federhen’s first draft depicting one of his original drawings.")]), _vm._v(" "), _c('p', {
    staticClass: "aut"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jeaninne Surette Honstein")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0xii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A two-page spread from Federhen’s first draft.")]), _vm._v(" "), _c('p', {
    staticClass: "aut"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jeaninne Surette Honstein")])]), _vm._v(" "), _c('p', {
    staticClass: "border_lo"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There is some evidence that the primary composition of the manuscript probably occurred around 1877. In his initial first-draft version of the manuscript, Federhen ends his narrative during his second imprisonment in Bonham, Texas, and then proceeds, as he puts it, to “coppy from a Kansas newspaper the Sack of Lawrence, by the noted Guerilla Quantral, written by Maj. John Edwards of Missouri, an Ex Confederate.” As it turns out, an article on that very topic was published in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saline County Journal")]), _vm._v(" of Salina, Kansas, on March 8, 1877."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/fxiii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A two-page spread from Federhen’s revised manuscript.")]), _vm._v(" "), _c('p', {
    staticClass: "aut"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jeaninne Surette Honstein")])]), _vm._v(" "), _c('p', {
    staticClass: "border_lo"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At a later unknown date Federhen made a fair copy that also revised his earlier draft. The transcription you are about to read was made from the second version of his text. The revisions consist of rephrasing sentences and paragraphs. There was no important stories added or removed up through"), _c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }), _vm._v(" the point at which the first draft terminated. The conclusion of the narrative appears only in the second draft.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both manuscripts were passed down through Federhan’s dependents until they were held by Oscar’s adopted grandson, William Federhen Surette. William passed them to his daughter, Jeaninne Surette Honstein of Princeton, New Jersey. Jeaninne transcribed the revised manuscript, and Steven A. Knowlton annotated the document in 2017 and 2018. The spelling, punctuation, and grammar of the manuscript have been preserved. Chapter titles were added by the editors.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Convoluted punctuation and grammar notwithstanding, Federhen’s narrative is a compelling tale. His keen eye for detail is novelistic in its flair, and his ability to convey desperation and danger in just a few words would have made him a successful writer of dime novels. There is a powerful flow to the story such that a reader cannot help but worry about and cheer for Federhen during his many escapades. His account of the last months of the Civil War carry with it a vividness that most non-fiction accounts rarely aspire to achieve.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While many key elements and observations Federhen recorded can be confirmed by the historical record, others are more suspect. In at least one instance, Federhen claims to have encountered historical figures who could not have been in the place he described at the time he claims to have been there. Notorious Confederate guerrilla leader William T. “Bloody Bill” Anderson, for example, was dead by the time Federhen claims he made his way into Indian Territory, and William Quantrill’s Raiders had dispersed into Missouri, Kentucky, and Tennessee by the time Federhen writes about riding with them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Similar problems arise trying to corroborate Federhen’s stories of escape from various Confederate installations, but that is unsurprising given the sparse nature of Southern record keeping during the last year of the war, and especially"), _c('a', {
    attrs: {
      "id": "page_xv"
    }
  }), _vm._v(" in that part of the Trans-Mississippi Theater. Some of Federhen’s escapes seem fanciful, but they correspond with the accounts of other escapees such Aaron Sutton and S. A. Swiggett."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2",
      "id": "rfn2"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("His stories of robbery, murder, and mayhem were not uncommon in that region, especially during the ending months of the Civil War when irregulars, guerillas, and outright criminals roamed the prairies from Missouri all the way south to the Rio Grande. We know with certainty that he was captured in May of 1864 and returned as a prisoner of war about a year later. He spent those eventful months doing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("something")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("somewhere")]), _vm._v(", and his version of what he did and where is inside these pages.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Readers will have to judge for themselves the reliability of Federhen’s account; we have faith few will deny that it is a gripping tale and one you won’t soon forget.")]), _vm._v(" "), _c('p', {
    staticClass: "notet"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")]), _vm._v(" Federhen may have seen the article “The Sack of Lawrence from Its Inception to Its Ghastly Culmination,” published in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Saline County Journal")]), _vm._v(" (Salina, Kansas) on March 8, 1877. According to the paper, the story was originally filed by the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Chicago Times")]), _vm._v("’ St. Louis correspondent.")]), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")]), _vm._v(" See, for example, David G. MacLean, ed., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Prisoner of the Rebels in Texas: The Civil War Narrative of Aaron T. Sutton")]), _vm._v(" (Decatur, IN: Americana Books, 1978), and S. A. Swiggett, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Bright Side of Prison Life")]), _vm._v(" (Baltimore: Fleet, McGinley, & Co., 1897).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08bcd3e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/09_Editors_Preface.vue
// module id = 84
// module chunks = 0